import { locales } from '@/translations/translations.constants'

export const getLocaleFromUtmSource = (utmSource?: string | null): TLocale | undefined => {
  if (!utmSource) return undefined

  return locales.find((locale) => utmSource.endsWith(`_${locale}`))
}
